import dayjs from "dayjs";

const fields = [
  {
    type: "bsx-input",
    inputType: "text",
    label: "名稱",
    model: "name",
    max: "12",
    required: true,
    readonly: false,    
  },
  {
    type: "bsx-upload",
    label: "頭像圖片",
    help: "寬：1030 px, 高：450 px",
    model: "avatar",
    kind: "button",
    required: true,
    browse: true,
    preview: true,
    accept: ".jpg,.png",
    folder: "banner",
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-select",
    label: "連結類型",
    model: "link_type",
    required: true,
    values: [
      { id: "external", name: "外部連結" },
      { id: "internal", name: "內部鏈接" },
    ],
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "text",
    label: "連結",    
    model: "link",
    placeholder: "請輸入連結",
    labelRemark: '請輸入連結 (如：https://) ',
    required: true,
    validator: function () {
      this.validation();
    },
  },  
  {
    type: "bsx-input",
    inputType: "number",
    label: "排序權重",
    hint: "權重數字越大，排序越前；若數字相同，則 ID 越大，排序越前",
    model: "sort",
    placeholder: "排序權重",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '是否啟用',
    model: 'is_enabled',
    required: true,
    textOn: '是',
    textOff: '否',
    valueOn: 1,
    valueOff: 0,
  },
];

export default fields;
